import * as React from 'react';
export var defaultLangStrings = {};
export var LangStringsContext = React.createContext(defaultLangStrings);
export var LangStringsProvider = LangStringsContext.Provider;